var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadDocIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 15,
    viewBox: "0 0 13 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.1312 5.07011H8.81826V0.94125C8.81826 0.487076 8.44666 0.115479 7.99249 0.115479H4.6894C4.23523 0.115479 3.86363 0.487076 3.86363 0.94125V5.07011H2.55066C1.81572 5.07011 1.44412 5.96194 1.96436 6.48218L5.75465 10.2725C6.0767 10.5945 6.59694 10.5945 6.91899 10.2725L10.7093 6.48218C11.2295 5.96194 10.8662 5.07011 10.1312 5.07011ZM0.560547 13.3278C0.560547 13.782 0.932144 14.1536 1.38632 14.1536H11.2956C11.7497 14.1536 12.1213 13.782 12.1213 13.3278C12.1213 12.8736 11.7497 12.502 11.2956 12.502H1.38632C0.932144 12.502 0.560547 12.8736 0.560547 13.3278Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadDocIcon);
export default __webpack_public_path__ + "static/media/download-doc-icon.fc55d2174e9161abfda0f849bb1bbdd0.svg";
export { ForwardRef as ReactComponent };